import React from 'react';
import classNames from 'classnames'

import { SidebarHeader } from './SidebarHeader';
import { SidebarBody } from './SidebarBody';

export const SidebarPanel = ({ title, closeAction, children, isOpen, options }) => (
    
    <div className={classNames(
        'bg-white w-full pt-[66px] pb-[40px] fixed right-0 top-[64px] bottom-[90px] z-20 transition-all overflow-hidden lg:w-[400px] lg:pb-8 lg:top-5 lg:right-5 lg:bottom-5 lg:rounded-xl lg:shadow-xl',
        {
            'opacity-100 visible -translate-y-0 lg:-translate-y-0 lg:translate-x-0': isOpen,
            'opacity-0 invisible -translate-y-3 lg:-translate-y-0 lg:translate-x-16': !isOpen
        }
    )}>

        <SidebarHeader title={title} closeAction={closeAction} options={options} />

        <SidebarBody children={children} />

    </div>
);
